module.exports = __webpack_public_path__ + "0b21e0793bdfbb356e265f9e345a9d26.svg";